import { nearestFeaturePolygonsFromLayer } from "./parkingGIS";

function getSecteurFromId(secteurs, id) {
  var val = "null";
  secteurs.forEach((row) => {
    if (row.code === id) {
      val = row;
    }
  });
  return val;
}

function matMatchingPolygon(layer, coord, callback) {
  var feature = nearestFeaturePolygonsFromLayer(coord, layer);
  if (feature !== null && feature !== undefined) {
    var featureProp = feature.getProperties();
    if (featureProp !== null) {
      if (typeof callback === "function") {
        callback(featureProp);
      }
    }
  } else {
    callback(null);
  }
}

export { getSecteurFromId, matMatchingPolygon };
